var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "m-2",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_777)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_276_777",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5568 9.81819H12.375V14.4546H18.8114C18.2114 17.4 15.7023 19.0909 12.375 19.0909C8.44773 19.0909 5.28409 15.9273 5.28409 12C5.28409 8.07273 8.44773 4.90909 12.375 4.90909C14.0659 4.90909 15.5932 5.50909 16.7932 6.49091L20.2841 3C18.1568 1.14545 15.4296 0 12.375 0C5.72046 0 0.375 5.34546 0.375 12C0.375 18.6546 5.72046 24 12.375 24C18.375 24 23.8296 19.6364 23.8296 12C23.8296 11.2909 23.7205 10.5273 23.5568 9.81819Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_276_777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.715881 19.0909V4.90912L8.55685 12L-0.715881 19.0909Z",
    fill: "#FBBC05"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_276_777",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5568 9.81819H12.375V14.4546H18.8114C18.2114 17.4 15.7023 19.0909 12.375 19.0909C8.44773 19.0909 5.28409 15.9273 5.28409 12C5.28409 8.07273 8.44773 4.90909 12.375 4.90909C14.0659 4.90909 15.5932 5.50909 16.7932 6.49091L20.2841 3C18.1568 1.14545 15.4296 0 12.375 0C5.72046 0 0.375 5.34546 0.375 12C0.375 18.6546 5.72046 24 12.375 24C18.375 24 23.8296 19.6364 23.8296 12C23.8296 11.2909 23.7205 10.5273 23.5568 9.81819Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_276_777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.715881 4.90912L8.55685 12L12.375 8.67276L25.4659 6.54549V-1.09088H-0.715881V4.90912Z",
    fill: "#EA4335"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_276_777",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5568 9.81819H12.375V14.4546H18.8114C18.2114 17.4 15.7023 19.0909 12.375 19.0909C8.44773 19.0909 5.28409 15.9273 5.28409 12C5.28409 8.07273 8.44773 4.90909 12.375 4.90909C14.0659 4.90909 15.5932 5.50909 16.7932 6.49091L20.2841 3C18.1568 1.14545 15.4296 0 12.375 0C5.72046 0 0.375 5.34546 0.375 12C0.375 18.6546 5.72046 24 12.375 24C18.375 24 23.8296 19.6364 23.8296 12C23.8296 11.2909 23.7205 10.5273 23.5568 9.81819Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_276_777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.715881 19.0909L15.6478 6.54549L19.9569 7.09094L25.4659 -1.09088V25.0909H-0.715881V19.0909Z",
    fill: "#34A853"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_276_777",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5568 9.81819H12.375V14.4546H18.8114C18.2114 17.4 15.7023 19.0909 12.375 19.0909C8.44773 19.0909 5.28409 15.9273 5.28409 12C5.28409 8.07273 8.44773 4.90909 12.375 4.90909C14.0659 4.90909 15.5932 5.50909 16.7932 6.49091L20.2841 3C18.1568 1.14545 15.4296 0 12.375 0C5.72046 0 0.375 5.34546 0.375 12C0.375 18.6546 5.72046 24 12.375 24C18.375 24 23.8296 19.6364 23.8296 12C23.8296 11.2909 23.7205 10.5273 23.5568 9.81819Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_276_777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4659 25.0909L8.55682 12L6.375 10.3637L25.4659 4.90912V25.0909Z",
    fill: "#4285F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.cd35bc4b9930d8517bf3723b203925af.svg";
export { ForwardRef as ReactComponent };